module.exports = __webpack_public_path__ + "app/bento-components/video-list/media/new_passport.svg?93ed45e48b9f639e7268a899f02ecb10";